// extracted by mini-css-extract-plugin
export default {"redirectPageWrapper":"redirect_redirectPageWrapper__mvAOe"};